import { createContext, useContext, useState } from 'react';

import { FCWithChildren } from 'common/types';

// Context
export interface MandateCreationFlowSharedState {
  createdMandateId: string;
  isB2bMandate: boolean | undefined;
  mandate: {
    creditorIdentifier: string;
    creditorName: string;
    file: {
      bucketName: string;
      fileName: string;
      fileRef: string;
      publicUrl: string;
    };
    label: string;
    uniqueMandateReference: string;
    bankAccountId: string;
  };
}

interface MandateCreationFlowContext {
  sharedState: MandateCreationFlowSharedState;
  setSharedState: (sharedState: MandateCreationFlowSharedState) => void;
}

const MANDATE_CREATION_FLOW_CONTEXT = createContext<
  MandateCreationFlowContext | undefined
>(undefined);

// Provider
const INITIAL_SHARED_STATE: MandateCreationFlowSharedState = {
  createdMandateId: '',
  isB2bMandate: undefined,
  mandate: {
    bankAccountId: '',
    creditorIdentifier: '',
    creditorName: '',
    file: {
      bucketName: '',
      fileName: '',
      fileRef: '',
      publicUrl: '',
    },
    label: '',
    uniqueMandateReference: '',
  },
};

export const MandateCreationFlowContextProvider: FCWithChildren = (props) => {
  const { children } = props;

  const [sharedState, setSharedState] = useState(INITIAL_SHARED_STATE);

  return (
    <MANDATE_CREATION_FLOW_CONTEXT.Provider
      value={{
        setSharedState,
        sharedState,
      }}
    >
      {children}
    </MANDATE_CREATION_FLOW_CONTEXT.Provider>
  );
};

// Hook
export function useMandateCreationFlowContext() {
  const context = useContext(MANDATE_CREATION_FLOW_CONTEXT);
  if (!context) {
    throw new Error(
      '"useMandateCreationFlowContext" can only be used under MandateCreationFlowContextProvider',
    );
  }
  return context;
}
